export function getApiUrl(): string {
  return import.meta.env.VITE_API_BASE_URL || 'http://localhost:8081'
}

export function getClientUrl(): string {
  // Use current window location as the client URL
  const { protocol, hostname, port } = window.location
  return `${protocol}//${hostname}${port ? `:${port}` : ''}`
}

export function getGoogleOAuthUrl(redirectPath?: string): string {
  const apiUrl = getApiUrl()
  const clientUrl = getClientUrl()
  const defaultRedirect = `${clientUrl}/dashboard`
  const redirect = redirectPath ? `${clientUrl}${redirectPath}` : defaultRedirect
  
  return `${apiUrl}/api/auth/google/login?redirect=${encodeURIComponent(redirect)}`
}

export function handleGoogleSSO(redirectPath?: string): void {
  // Store intended destination in sessionStorage
  if (redirectPath) {
    sessionStorage.setItem('oauth_redirect', redirectPath)
  }
  
  window.location.href = getGoogleOAuthUrl(redirectPath)
}